import {PatientLookupActions} from "../const/ActionsConst";
import {MessageBoxTypes} from "../const/ActionsConst";
const I18n = require('react-redux-i18n').I18n;
let rest = require('rest');
let mime = require('rest/interceptor/mime');
let client = rest.wrap(mime, { mime: 'application/json' });

export const showMessageBoxBasedOnData = (type, show, header, text, confirmText, cancelText, size = 'small', data, showInput) => ({
    type: PatientLookupActions.SHOW_MESSAGE_BOX_BASED_ON_DATA,
    messageBox: {
        type: type,
        show: show,
        header: header,
        text: text,
        confirmText: confirmText,
        cancelText: cancelText,
        size: size,
        data: data,
        showInput: showInput
    }
});

export const showMessageBox = (show, type, size = 'small') => ({
    type: PatientLookupActions.SHOW_MESSAGE_BOX,
    messageBox: {
        type: type,
        show: show,
        size: size
    }
});

export const messageBoxConfirmed = (type, data) => {
    return (dispatch, getState) => {
        switch (type) {
            case MessageBoxTypes.CREATE_NEW_RECORD:
                dispatch(checkPatientAndCreateNewRecord(data));
                break;
            case MessageBoxTypes.RELOAD:
                location.reload(true);
                break;
        }
    }
};

export const messageBoxInputValueChanged = (value) => ({
    type: PatientLookupActions.MESSAGE_BOX_INPUT_VALUE_CHANGED,
    messageBox: {
        data: value
    }
});

export const changePatientSearchValue = (newValue) => ({
    type: PatientLookupActions.CHANGE_PATIENT_SEARCH_VALUE,
    newValue: newValue
});

export const setCurrentStep = (step) => ({
    type: PatientLookupActions.SET_CURRENT_STEP,
    step: step
});

export const setPatientsList = (patients) => ({
    type: PatientLookupActions.SET_PATIENTS_LIST,
    patients: patients
});

export const selectPatient = (patient) => ({
    type: PatientLookupActions.SELECT_PATIENT,
    patient: patient
});

export const changePatientDOBValue = (dateOfBirth) => ({
    type: PatientLookupActions.CHANGE_PATIENT_DOB_VALUE,
    dateOfBirth: dateOfBirth
});

export const searchPatient = () => (dispatch, getState) => {
    let search = "value=" + getState().patients.searchValue + "&" + "qid=" + getState().questionnaire.id;
    client({
        path: 'api/patientLookup/search?' + search,
        headers: {'Pragma': 'no-cache'}
    }).then(
        response => {
            if (response.entity.length === 0) {
                if (getState().questionnaire.createNewRecords) {
                    let text = getState().questionnaire.mrnField + " " +  I18n.t('MRN not found');
                    dispatch(showMessageBoxBasedOnData(MessageBoxTypes.CREATE_NEW_RECORD, true, I18n.t('Confirmation message'), text, I18n.t('Confirm'), I18n.t('Cancel'), 'small', undefined, true));
                } else {
                    dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('No results found'), I18n.t('No results found message'), undefined, I18n.t('Close')));
                }
            } else {
                dispatch(setPatientsList(response.entity));
                dispatch(setCurrentStep(2));
                if (response.entity.length === 1) {
                    dispatch(selectPatient(response.entity[0]));
                }
            }
        },
        error => {
            if (checkForTimeout(error, dispatch)) return;
            dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('No results found'), I18n.t('No results found message'), undefined, I18n.t('Close')));
            console.log('Search Patient failed: ', error);
        }
    )
};

export const validate = () => (dispatch, getState) => {
    client({
        path: 'api/patientLookup/validate',
        method: 'POST',
        entity: {
            qid: getState().questionnaire.id,
            url: getState().progenyInfo.baseUrl,
            globalId: getState().patients.selected.globalId,
            date: getState().patients.enteredDOB ? getState().patients.enteredDOB.format('MM/DD/YYYY') : ''
        }
    }).then(
        response => {
            if (!response.entity.url) {
                dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('dob_validation_failed'), I18n.t('dob_validation_failed_msg'), undefined, I18n.t('Close')));
            } else {
                window.location.href = response.entity.url;
            }
        },
        error => {
            if (checkForTimeout(error, dispatch)) return;
            dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('dob_validation_failed'), I18n.t('dob_validation_failed_msg'), undefined, I18n.t('Close')));
        }
    )
};

export const checkPatientAndCreateNewRecord = (patientId) => (dispatch, getState) => {
    if (getState().patients.searchValue === patientId) {
        let search = "value=" + patientId + "&" + "qid=" + getState().questionnaire.id;
        client({
            path: 'api/patientLookup/search?' + search,
            headers: {'Pragma': 'no-cache'}
        }).then(
            response => {
                if (response.entity.length === 0) {
                    dispatch(createNewRecord(patientId));
                } else {
                    dispatch(showMessageBox(false));
                    dispatch(setPatientsList(response.entity));
                    dispatch(setCurrentStep(2));
                    if (response.entity.length === 1) {
                        dispatch(selectPatient(response.entity[0]));
                    }
                }
            },
            error => {
                if (checkForTimeout(error, dispatch)) return;
                dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('Unable to create new pedigree'), I18n.t('Unable to create new pedigree message'), undefined, I18n.t('Close')));
                console.log('Search Patient failed: ', error);
            }
        )
    } else {
        let header = I18n.t('Values dont match');
        let text = I18n.t('Entered') + " " + getState().questionnaire.mrnField + " " + I18n.t('is not matching firstly entered') + " " + getState().questionnaire.mrnField;
        dispatch(showMessageBoxBasedOnData(undefined, true, header, text, undefined, I18n.t('Close')));
        dispatch(changePatientSearchValue(''));
    }
};

export const createNewRecord = (patientId) => (dispatch, getState) => {
    client({
        path: 'api/patientLookup/create',
        method: 'POST',
        entity: {
            qid: getState().questionnaire.id,
            patientId: patientId,
            url: getState().progenyInfo.baseUrl,
        }
    }).then(
        response => {
            if (response.entity.url) {
                window.location.href = response.entity.url;
            } else {
                dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('Unable to create new pedigree'), I18n.t('Unable to create new pedigree message'), undefined, I18n.t('Close')));
            }
        },
        error => {
            if (checkForTimeout(error, dispatch)) return;
            dispatch(showMessageBoxBasedOnData(undefined, true, I18n.t('Unable to create new pedigree'), I18n.t('Unable to create new pedigree message'), undefined, I18n.t('Close')));
            console.log('Pedigree creating failed: ', error);
        }
    )
};

export const setEnteredDOBValid = (valid) => ({
    type: PatientLookupActions.VALIDATE_ENTERED_DOB,
    valid: valid
});

const checkForTimeout = (response, dispatch) => {
    if (response.entity === 'session_timeout') {
        dispatch(showMessageBoxBasedOnData(MessageBoxTypes.RELOAD, true, I18n.t('session_timeout'), I18n.t('session_timeout_msg'), I18n.t('reload'), undefined));
        return true;
    }
};
